/* eslint-disable react/require-default-props */
import React from 'react';
export function BrushawayFooter({ children, startActions, className = '' }) {
    const footerClasses = ['qmb-ui-brushaway-footer', className].filter(Boolean).join(' ');
    return (React.createElement("div", { className: footerClasses, role: "contentinfo" },
        React.createElement("div", { className: "qmb-ui-brushaway-footer__content" },
            startActions && React.createElement("div", { className: "qmb-ui-brushaway-footer__start" }, startActions),
            React.createElement("div", { className: "qmb-ui-brushaway-footer__actions" }, children))));
}
